// Import GSAP
import { gsap } from 'gsap'



// VARIABLES
const rootElement = document.documentElement



export function parallaxAnimation( animateElements:any[] ) {
  rootElement.addEventListener( 'mousemove', e => executeParallax(e, rootElement, animateElements) )
}



function executeParallax( e:MouseEvent, rootElement:HTMLElement, animateElements:any[] ) {
  const windowWidth:number = window.outerWidth
  const windowHeight:number = window.outerHeight
  const x:number = e.pageX - rootElement.offsetLeft
  const y:number = e.pageY - rootElement.offsetTop
  const newX:number = x - windowWidth / 2
  const newY:number = y - windowHeight / 2
  const percentage:number = 50

  animateElements.map( animateEl => moveParallax(newX, newY, percentage, animateEl) )
  //console.log(animateElements);
}

function moveParallax( newX:number, newY:number, percentage:number, animateEl:any ) {
  
    if( !animateEl.current ) return false

    let speed:number = animateEl.current.dataset.speed
    let revert:string = animateEl.current.dataset.revert
    let posX:number = newX
    let posY:number = newY

    if( revert ) speed = speed * -1

    if( percentage > 0 ) {
        posX = (posX / 100) * percentage
        posY = (posY / 100) * percentage
    }

    gsap.to(animateEl.current, {
      duration: 1,
      x: posX * speed,
      y: posY * speed
    })
}
